import AlertStatusTag from "../../../AlertsPage/components/AlertStatusTag/AlertStatusTag"
import { AlertDate, AlertSource, Amount, Card, Customer, TransactionId } from "./fields"

// `AlertStatusTag` is the Alerts screen's own cell, which is what makes the remaining-time counter
// follow the same rule here; disabled, because Home reads alerts rather than resolves them.
export const getActionAlertsColumns = ({ t, theme, isDemo }) => [
  {
    key: "alert_status",
    title: t("Status"),
    dataIndex: "alert_status",
    width: 180,
    // `AlertStatusTag` is built to fill its row (`flex: 1`); a table cell wants it to hug.
    render: (_, record) => (
      <div style={{ width: "fit-content" }}>
        <AlertStatusTag alert={record} disabledStatus isDemo={isDemo} />
      </div>
    )
  },
  {
    key: "customer",
    title: t("Customer"),
    dataIndex: "customer_full_name",
    width: 200,
    render: (_, record) => <Customer alert={record} />
  },
  {
    key: "transaction_id",
    title: t("Transaction ID"),
    dataIndex: "transaction_id",
    width: 170,
    render: (_, record) => <TransactionId alert={record} />
  },
  {
    key: "alert_service",
    title: t("Alert source"),
    dataIndex: "alert_service",
    width: 150,
    render: (_, record) => <AlertSource alert={record} theme={theme} />
  },
  {
    key: "amount",
    title: t("Amount"),
    dataIndex: "converted_amount",
    width: 130,
    render: (_, record) => <Amount alert={record} />
  },
  {
    key: "card_last4",
    title: t("Card"),
    dataIndex: "card_last4",
    width: 170,
    render: (_, record) => <Card alert={record} theme={theme} />
  },
  {
    key: "alert_timestamp",
    title: t("Date"),
    dataIndex: "alert_timestamp",
    width: 130,
    render: (_, record) => <AlertDate alert={record} />
  }
]
